import styles from './team.module.scss';
import { useKeenSlider } from 'keen-slider/react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import clsx from 'clsx';

const Member = ({ data }) => {
  return (
    <div className={styles.member}>
      <div className={styles.memberName}>{data.title}</div>
      <div className={styles.memberPosition}>{data.post}</div>
      <div className={styles.memberPhoto}>
        {data.image && <img src={data.image} alt={data.title} />}
      </div>
    </div>
  );
};

const variants = {
  initial: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.3,
      delay: 0.5,
    },
  },
  hidden: { opacity: 0 },
};

const Team = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px',
  });

  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    slidesPerView: 1.5,
    spacing: 0,
    duration: 700,
    breakpoints: {
      '(min-width: 768px)': {
        slidesPerView: 3,
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  return (
    <motion.div ref={ref} className={styles.wrapper}>
      <motion.h2
        className={styles.header}
        exit={{
          opacity: 0,
          y: '-15%',
          transition: { duration: 0.3 },
        }}
        initial={{
          overflow: 'hidden',
          width: '0%',
          whiteSpace: 'nowrap',
        }}
        animate={
          inView
            ? {
                width: '100%',
                transition: { duration: 2, delay: 0.3 },
              }
            : 'false'
        }
      >
        Команда
      </motion.h2>
      <motion.div
        className={styles.slider}
        initial="initial"
        animate={inView ? 'visible' : 'false'}
        exit="hidden"
        variants={variants}
      >
        <div ref={sliderRef} className={clsx('keen-slider', styles.keen)}>
          {data.map(member => (
            <div key={member.id} className="keen-slider__slide">
              <Member data={member} />
            </div>
          ))}
        </div>
        {slider && (
          <>
            <ArrowLeft onClick={e => e.stopPropagation() || slider.prev()} />
            <ArrowRight onClick={e => e.stopPropagation() || slider.next()} />
          </>
        )}
      </motion.div>
    </motion.div>
  );
};

const ArrowLeft = props => {
  return (
    <svg
      onClick={props.onClick}
      className={clsx(styles.arrow, styles.arrowLeft)}
      viewBox="0 0 54 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 36L21.1725 32.8275L8.6175 20.25H54V15.75H8.6175L21.195 3.195L18 0L0 18L18 36Z"
        fill="#BCA169"
      />
    </svg>
  );
};

const ArrowRight = props => {
  return (
    <svg
      onClick={props.onClick}
      className={clsx(styles.arrow, styles.arrowRight)}
      viewBox="0 0 54 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 3.8147e-06L32.8275 3.1725L45.3825 15.75L0 15.75L0 20.25L45.3825 20.25L32.805 32.805L36 36L54 18L36 3.8147e-06Z"
        fill="#BCA169"
      />
    </svg>
  );
};

export default Team;
